module.exports = __webpack_public_path__ + "img/pay1.44c5fce1.png";